export const AUTH_CREDS_NOT_PROVIDED = 'Authentication credentials were not provided.'
export const INVALID_TOKEN = 'Invalid token.'
